import { render, staticRenderFns } from "./TabelaProcessosTotais.vue?vue&type=template&id=e9c9a35e"
import script from "./TabelaProcessosTotais.vue?vue&type=script&lang=js"
export * from "./TabelaProcessosTotais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports